<template>
  <a-config-provider :locale="locale">
    <router-view />
  </a-config-provider>
</template>
<script setup>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
const locale = zhCN;
</script>
<style>
.success-bg {
  background: #00ff00;
}
.offline-bg {
  background: #fab421;
}
.warn-bg {
  background: #ef573f;
}
.hitch-bg {
  background: #ec2745;
}

.success-color {
  color: #00ff00;
}
.offline-color {
  color: #fab421;
}
.warn-color {
  color: #ef573f;
}
.hitch-color {
  color: #ec2745;
}
</style>
